/*
 * VNCmail : A whole new experience in enterprise email communication.
 * Copyright (C) 2015-2020 VNC – Virtual Network Consult AG (info@vnc.biz)
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, version 3 of the License.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. Look for COPYING file in the top folder.
 * If not, see http://www.gnu.org/licenses/.
 */

import { Component, HostListener, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Observable } from "rxjs";
import { VNCInputComponent } from "@uxf/vnc-library";
import { FormControl, FormGroup } from "@angular/forms";
import { FileInfo } from "src/app/shared/owncloud.service";
import { MailUtils } from "src/app/mail/utils/mail-utils";
import { environment } from "src/environments/environment";
import { ConfigService } from "src/app/config.service";
import { DateAdapter } from "@angular/material/core";

@Component({
  selector: "vp-owncloud-public",
  templateUrl: "./owncloud-public.html"
})
export class OwncloudPublicDialogComponent implements OnInit, OnDestroy {
  permission = "1";
  dataType = "password";
  linkName: FormControl = new FormControl("", []);
  password: FormControl = new FormControl("", []);
  minDate = new Date();
  expirationDate: FormControl = new FormControl("", []);
  owncloudGroup: FormGroup;
  conversations = [];
  contacts = [];
  filteredOptions$: Observable<any[]>;
  file: FileInfo;
  lang: string = "en";
  isEdit: any;
  @ViewChild(VNCInputComponent) input: VNCInputComponent;
  private isAlive$ = new Subject<boolean>();

  constructor(
    private dialog: MatDialogRef<OwncloudPublicDialogComponent>,
    private configService: ConfigService,
    private dateAdapter: DateAdapter<any>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.minDate.setDate(this.minDate.getDate() + 1);
    this.file = this.data.file;
    if (this.data.isEdit) {
      this.isEdit = true;
      this.permission = this.file.permissions.toString();
      this.linkName.patchValue(this.file.sharedName);
      if (this.file.expiration) {
        this.expirationDate.patchValue(this.file.expiration);
      }
    }
    this.configService.currentLanguage.pipe(takeUntil(this.isAlive$)).subscribe(lang => {
      this.lang = lang;
      this.dateAdapter.setLocale(lang);
    });
    if (!!this.data.data) {
      if (this.data.data.expirationDate) {
        this.expirationDate.patchValue(this.data.data.expirationDate);
      }
      if (this.data.data.permissions) {
        this.permission = this.data.data.permissions.toString();
      }
      if (this.data.data.password) {
        this.dataType = "text";
        this.password.patchValue(this.data.data.password);
      }
      if (this.data.data.name) {
        this.linkName.patchValue(this.data.data.name);
      }

    }
  }

  get isMobileSize () {
    return MailUtils.isMobileSize();
  }

  ngOnInit() {
    this.owncloudGroup = new FormGroup({
      expirationDate: this.expirationDate
    });

    setTimeout(() => {
      if (!!document.querySelector("#linkName input")) {
        (<HTMLInputElement>document.querySelector("#linkName input")).focus();
      }
    }, 500);
    if (environment.isCordova) {
      StatusBar.backgroundColorByHexString("#000000");
      StatusBar.styleBlackTranslucent();
    }
  }

  ngOnDestroy() {
    this.isAlive$.next(false);
    this.isAlive$.complete();
    if (document.querySelector(".dialog-backdrop") !== null) {
      (<HTMLElement>document.querySelector(".dialog-backdrop")).style.display = "none";
    }
    if (environment.isCordova) {
      StatusBar.backgroundColorByHexString("#317bbc");
    }
  }

  @HostListener("document:keydown.esc")
  cancel(): void {
    this.dialog.close();
  }

  delete() {
    this.dialog.close({deleted: true});
  }

  copy() {
    this.dialog.close({copied: true});
  }

  async share() {
    if (this.linkName.value && this.linkName.value.trim().length > 0) {
      this.dialog.close({ shared: true, password: this.password.value, permission: this.permission, expirationDate: this.expirationDate.value, name: this.linkName.value });
    }
  }

  toggleType() {
    this.dataType = this.dataType === "text" ? "password" : "text";
  }

}
